import Hls from "hls.js";
import {createEventListener, currentBrowser} from "./tools";
import PlayerToolBar from "./player.toolbar";
import Entity from "./entity";

const isFlussonicStream = (stream) => {
    return stream?.server()[0].type() === 'flussonic';
}

function PlayerHTML($app) {
	const self = this;

	const $ui = $app.require('ui');

	const isLoaded = ko.observable(false);
	const isLoading = ko.observable(false);
	const playerStartTime = ko.observable(-1);
	let playerContainer;
	let video;
	let toolBar;
	let hls;

	let lastSeekPromise;

	createEventListener(self);

	function createPlayer() {
		video = document.getElementById('Player');
        video.muted = true;
		video.controls = false;
		video.autoplay = true;

		video.addEventListener('canplay', function() { self.canplay(true); });
		video.addEventListener('canplaythrough', function() { self.canplay(true); });
		video.addEventListener('seeked', function() { if(lastSeekPromise) {lastSeekPromise.resolve();} self.canplay(true); });
		video.addEventListener('durationchange', function() { self.durationPlayer(video.duration); });
		video.addEventListener('play', function() {
            self.paused(false);
            self.muted(video.muted = false);
        });
		video.addEventListener('pause', function() { self.paused(true); });
		video.addEventListener('timeupdate', function() { self.currentTime(video.currentTime); });
		video.addEventListener('volumechange', function() { self.volume(video.volume); self.muted(video.muted); });
		video.addEventListener('waiting', function() { self.canplay(false); });
		video.addEventListener('ended', function() { self.trigger('ended'); });
		video.addEventListener('error', function() {
			const errors = [null,
				'MEDIA_ERR_ABORTED',
				'MEDIA_ERR_NETWORK',
				'MEDIA_ERR_DECODE',
				'MEDIA_ERR_SRC_NOT_SUPPORTED'
			];
			console.error('Player Error', errors[video.error?.code] || video.error);
		});

		if(!currentBrowser.isMobile()) {
			video.addEventListener('click', function () {
				self.trigger(self.paused() ? 'play' : 'pause');
			});
		}

		$(playerContainer)
			.on('contextmenu', function(event) {
				var $playerContextMenu = $('#playerContextMenu');
				var x = event.clientX;
				var y = event.clientY;
				var playerWidth = $(playerContainer).width();
				var playerHeight = $(playerContainer).height();

				event.preventDefault();

				$playerContextMenu.css({
					left: x < playerWidth / 2 ? x : x - $playerContextMenu.width(),
					top: y < playerHeight / 2 ? y : y - $playerContextMenu.height()
				});
				toolBar.isShowContextMenu(true);
				return false;
			})
		;

		self.volume(video.volume);
		self.muted(video.muted);
		self.paused(video.paused);

		self.trigger('load');
	}

	function createToolBar() {
		toolBar = new PlayerToolBar($app, self);
		toolBar.isVolumeEnabled(!currentBrowser.isMobile());
		toolBar.on('currentTime', function(currentTime) { self.setCurrentTime(currentTime); });
		toolBar.on('play', function() { self.playVideo(); !self.hasDVR() ? setTimeout(function() { self.setLive()}, 10) : null; });
		toolBar.on('pause', function() { video.pause(); });
		toolBar.on('muted', function(mute) { video.muted = mute; });
		toolBar.on('volume', function(volume) { video.volume = volume; });
		toolBar.on('live', function() { self.setLive(); });
		toolBar.on('quality', function(quality) { self.quality(quality); });
		toolBar.on('language', function(language) { self.language(language); });
        toolBar.on('pip', () => self.pipToggle());
		toolBar.on('resize', function() { $app.require('ui').playerSize.toggle(); });
		toolBar.on('fullScreen', function() { currentBrowser.isIOS() ? $(video).fullScreen() : $(playerContainer).fullScreen(); });

		toolBar.on('like', function() { $app.require('episode').like(); });
		toolBar.on('share', function() { $app.require('share').show(); });
		toolBar.on('compact', function() { $app.require('ui').playerSize.isCompactShow(true); });
	}

	function getPlayer() {
		if(!video) {
			createPlayer();
		}
		return video;
	}
	function getToolBar() {
		if(!toolBar) {
			createToolBar();
		}
		return toolBar;
	}

	function setSource(srcList) {
		let srcIndex = 0;
		let src = srcList && srcList[ srcIndex ] || null;

        function changeDeliveryNetwork() {
            if(undefined === srcList[++srcIndex]) {
                srcIndex = 0;
            }

            if (video.currentTime > 0) {
                playerStartTime(video.currentTime);
            }

            _setSource(srcList[srcIndex]);
        }

		return _setSource(src);

		function _setSource(src) {
			return new Promise(resolve => {
				video.pause();
				self.canplay(false);

				if((-1 !== document.cookie.indexOf('disable_hlsjs=')) || (currentBrowser.isMobile() && currentBrowser.isIOS())) {
					video.src = src;
                    self.playVideo();
				} else {
					hls && hls.destroy();

					if(src) {
                        let recoverMediaErrorCount = 0;
                        let startLoadCount = 0;

						let hlsConfig = {
//							maxBufferHole: 3,
                            maxBufferLength: 10,
                            maxMaxBufferLength: 30,
							startPosition: playerStartTime(),
                            startLevel: (self.quality()?.number() || 0) - 1,
						};
						hls = new Hls(hlsConfig);
                        self.hls = hls;
						hls.attachMedia(video);
						if (currentBrowser.isAndroid()) {
							self.playVideo();
						}
						hls.on(Hls.Events.MEDIA_ATTACHED, () => hls.loadSource(src));
						hls.on(Hls.Events.MANIFEST_PARSED, () => self.playVideo());
						hls.on(Hls.Events.ERROR, (event, data) => {
							console.error(event, data);

                            if (!data.fatal) {
                                return;
                            }

                            setTimeout(() => {
                                switch(data.type) {
                                    case Hls.ErrorTypes.MEDIA_ERROR:
                                        if (recoverMediaErrorCount < 3) {
                                            console.log('hls: try to recoverMediaError');
                                            recoverMediaErrorCount++;
                                            hls.recoverMediaError();
                                        } else {
                                            console.log('hls: changeDeliveryNetwork on mediaError');
                                            recoverMediaErrorCount = 0;
                                            changeDeliveryNetwork();
                                        }
                                        break;
                                    case Hls.ErrorTypes.NETWORK_ERROR:
                                        if (startLoadCount < 1 && data.details !== Hls.ErrorDetails.MANIFEST_LOAD_ERROR) {
                                            console.log('hls: try to startLoad');
                                            startLoadCount++;
                                            hls.startLoad();
                                        } else {
                                            console.log('hls: changeDeliveryNetwork on networkError');
                                            startLoadCount = 0;
                                            changeDeliveryNetwork();
                                        }
                                        break;
                                    default:
                                        console.log('hls: changeDeliveryNetwork on error: ' + data.type);
                                        changeDeliveryNetwork();
                                }
                            }, 100);
						});
					}
				}

				if (src) {
					function onCanPlayThrough(event) {
						video.removeEventListener(event.type, onCanPlayThrough);
						self.playVideo();
						resolve();
					}
					video.addEventListener('canplaythrough', onCanPlayThrough, false);
				} else {
					resolve();
				}
			});
		}
	}

    self.playVideo = () => {
        try {
            const playPromise = video.play();
            if (undefined !== playPromise) {
                playPromise
                    .then(() => {
                        console.debug('video play success');
                        self.autoplayAllowed(true);
                    })
                    .catch((e) => {
                        console.warn('video play failed', e);
                        self.autoplayAllowed(false);
                    })
                ;
            } else {
                console.debug('video play not an promise');
            }
        } catch (e) {
            console.error(e);
        }
    };

	self.currentSourceList = ko.observableArray();
	self.currentSource = ko.observable();

	self.getPlayer = function() { return getPlayer(); };
	self.getToolBar = function() { return getToolBar(); };

	self.template = ko.observable('html');

	self.button = {
		like: ko.computed(function() { return !!$app.currentEpisode() && $app.event().moduleEpisode.like(); }),
		likeActive: ko.computed(function() { return $app.currentEpisode() && $app.currentEpisode().liked(); }),
		share: ko.computed(function() { return $app.event().moduleBranding.share() && !$app.event().private(); }),
		compact: ko.computed(function() { return ($ui.playerSize.isCompact() || $ui.playerSize.isExpanded()) && !$ui.playerSize.isFullScreen(); }),
		resize: ko.computed(function() { return $ui.hasContainer('right') && $ui.hasContainer('bottom') && !$ui.playerSize.isCompact() && !$ui.playerSize.isFullScreen(); }),
		fullScreen: ko.observable(true),
	};

    self.autoplayAllowed = ko.observable(true);
	self.paused = ko.observable(false);
	self.volume = ko.observable(0);
	self.muted = ko.observable(false);
	self.currentTime = ko.observable(0);
	self.durationPlayer = ko.observable(0);
	self.durationSession = ko.computed(function() {
		if(!$app.currentStream()) {
            return 0;
		}

        return $app.currentStream().getBroadcastSession($app.currentStreamDay())
            .reduce((duration, session) => duration + session.duration(), 0);
	});
	self.duration = ko.computed(function() { return self.durationPlayer() !== Infinity && $app.currentStream() && $app.currentStream().dvr() ? self.durationPlayer() : self.durationSession(); });
	self.hasLive = ko.computed(function() { return !!($app.currentStream() && $app.currentStream().isLive()) && (!$app.episode() || $app.episode().type() === 'live'); });
	self.hasDVR = ko.computed(function() { return $app.currentStream() && $app.currentStream().dvr(); });
	self.virtualLive = ko.observable(false);
	self.live = ko.computed(function() {
		if($app.currentEpisode() && $app.currentEpisode().isRecorded()) return false;
		return self.hasLive() && self.virtualLive();
	});
	self.progress = ko.computed(function() { return self.live() ? 1 : (self.duration() ? self.currentTime() / self.duration() : 0); });
	self.channel = ko.observable();
	self.canplay = ko.observable(false);
	self.qualities = ko.computed(() => $app.currentStream()?.quality().sort((a, b) => b.number() - a.number()));
	self.quality = ko.observable();
	self.languages = ko.computed(() => $app.currentStream()?.language());
	self.language = ko.observable();
	self.playerExpanded =  $ui.playerSize.isExpanded;
	self.fullScreen = ko.observable(false);

	self.isShowBuffering = ko.computed(function() { return $app.currentStream() && self.autoplayAllowed() && ((!self.canplay() && isLoaded()) || isLoading()); });
	self.isShowNetworkError = ko.observable(false);
	self.isShowPlayButton = ko.observable(false);
	self.autoPlayTimeout = ko.observable(0);

	self.paused.subscribe(function(paused) { self.trigger('paused', [paused]); });
	self.volume.subscribe(function(volume) { self.trigger('volume', [volume]); });
	self.muted.subscribe(function(muted) { self.trigger('muted', [muted]); });
	self.currentTime.subscribe(function(currentTime) { self.trigger('currentTime', [currentTime]); });
	self.duration.subscribe(function(duration) { self.trigger('duration', [duration]); });
	self.channel.subscribe(function(channel) { self.trigger('channel', [channel]); });
	self.canplay.subscribe(function(canplay) { self.trigger('canplay', [canplay]); });
	self.quality.subscribe(function() {
        if(!$app.currentStream()) {
            return;
        }

        if (isFlussonicStream($app.currentStream()) && hls?.levels?.length > 1) {
            hls.currentLevel = self.quality().number() - 1;
            return;
        }

		const currentTime = self.live() ? -1 : self.currentTime();
        self.reload()
            .then(function() { return self.setCurrentTime(currentTime); })
        ;
	});
	self.language.subscribe(function() {
        if (!$app.currentStream()) {
            return;
        }

        if (isFlussonicStream($app.currentStream()) && hls?.audioTracks?.length > 1) {
            hls.audioTrack = ['left', 'right'].indexOf(self.language().channel());
            return;
        }

		const currentTime = self.live() ? -1 : self.currentTime();
        self.reload()
            .then(function() { return self.setCurrentTime(currentTime); })
        ;
	});
	self.hasLive.subscribe(function(hasLive) { hasLive ? self.setLive() : self.setCurrentTime(0); });

	self.episodes = ko.computed(function() {
		if(!$app.currentStream()) { return []; }
		if($app.currentStream().isEpisodeRecorded()) return [];
		if($app.currentEpisode() && $app.currentEpisode().isRecorded()) return [];

		let episodes = $app.currentStream().episode();
		if(in_array($app.currentStream().archiveStatus(), ['none', 'process'])) {
			episodes = episodes.filter(function(episode) {
				return episode.day() === $app.currentStreamDay();
			});
		}

		return episodes;
	});

	$(document).on('fullscreenchange', function() { self.fullScreen(!!$(document).fullScreenElement()); });

	self.on('play', function() { self.playVideo(); });
	self.on('pause', function() { video.pause(); });

	self.on('paused', function(paused) { if(paused) self.virtualLive(false); });

    self.pipToggle = () => {
        if (document.pictureInPictureElement) {
            document.exitPictureInPicture()
                .then(() => {})
                .catch((e) => console.error(e))
            ;
        } else {
            video.requestPictureInPicture()
                .then(() => {})
                .catch((e) => console.error(e))
            ;
        }
    };

	self.setPoster = function(src) {
		return new Promise(resolve => {
			video.setAttribute('poster', src);
			setTimeout(function() { resolve(); }, 0);
		});
	};

	self.setPaused = function(paused) {
		return new Promise(resolve => {
			paused ? getPlayer().pause() : getPlayer().play();
			setTimeout(function() { resolve(); }, 0);
		});
	};

	self.setCurrentTime = function(currentTime) {
		if(lastSeekPromise) {
			lastSeekPromise.reject();
		}

		return new Promise((resolve, reject) => {
			lastSeekPromise = {resolve, reject};

			function setCurrentTime(currentTime) {
                if (!$app.currentStream()?.dvr()) {
                    video.currentTime = 10;
                    self.virtualLive(true);
                } else if(!isNaN(currentTime) && currentTime >= 0) {
					currentTime = currentTime > self.duration() - 10 ? self.duration() - 10 : currentTime;
					video.currentTime = currentTime;
					self.virtualLive(false);
				} else {
					video.currentTime = self.duration() - 40;
					self.virtualLive(true);
				}
				lastSeekPromise.resolve();
			}

			if(self.canplay()) {
				setCurrentTime(currentTime);
//				resolve();
			} else {
				const d = self.canplay.subscribe(function(canPlay) {
					if(canPlay) {
						d.dispose();
						setCurrentTime(currentTime);
//						resolve();
					}
				});
			}
		});
	};

	self.setLive = function() {
		if($app.currentEpisode() && $app.currentEpisode().isRecorded()) {
			self.setStream($app.currentEpisode().stream());
		}
		return self.setCurrentTime(-1);
	};

	self.buttonEnable = function(name, enable) {
		return new Promise(resolve => {
			switch(name) {
				case 'schedule': name = 'on_air'; break;
			}
			getToolBar().buttonEnable(name, enable);
			setTimeout(function() { resolve(); }, 0);
		});
	};

	self.like = function(visible, state) {
		//getPlayer().setChaptersLike(visible, state);
	};

	self.reload = function() {
		self.currentSourceList(getStreamUrl());
		return setSource(self.currentSourceList());
	};

	function getStreamUrl() {
		const quality = self.quality();
		const language = self.language();
		const episode = $app.episode() && $app.episode().isRecorded() ? $app.episode() : ($app.currentEpisode() && $app.currentEpisode().isRecorded() ? $app.currentEpisode() : null);
		const streamDay = $app.currentStreamDay();
		return $app.currentStream() && $app.currentStream().getUrl(quality, language, episode, streamDay);
	}

	self.setStream = function(stream) {
		return self.load()
			.then(function() {
				try {
					if(stream) {
						if(!stream.dvr() && !stream.isLive()) {
							return Promise.reject('DVR disabled');
						}

						let quality = stream.quality().find(quality => quality.default()) || stream.quality()[0] || null;
						if(self.quality() && stream.quality()) {
							quality = stream.quality().find((quality) => quality.number() === self.quality().number()) || quality;
						}
                        if (self.quality() !== quality) {
                            self.quality(quality);
                        }

						let language = stream.language().find(language => language.default()) || stream.language()[0] || null;
						if(self.language() && stream.language()) {
							language = stream.language().find((language) => language.channel() === self.language().channel()) || language;
						} else {
							language = stream.language().find((language) => language.label().toLowerCase() === $app.require('locale').getName()) || language;
						}
                        if (self.language() !== language) {
                            self.language(language);
                        }

						playerStartTime(-1);

						self.setPoster(stream.getPreview());

                        let streamDay = 0;
						if(in_array(stream.status(), ['live', 'pause']) && !(stream.getStreamStream() instanceof Entity.Event.Stream)) {
							streamDay = stream.getStreamStream().day() || 0;
						}
                        $app.currentEpisode(null);
                        $app.currentStream(stream);
                        $app.currentStreamDay(streamDay);
					} else {
                        $app.currentEpisode(null);
                        $app.currentStream(null);
                        $app.currentStreamDay(0);
                    }
				} catch(e) {
					console.error('setStream', e);
				}

				return self.reload();
			})
		;
	};

	self.setEpisode = function(episode) {
		return self.load()
			.then(function() {
				try {
					const stream = episode.stream();

					if(!stream.dvr() && !stream.isLive()) {
						return Promise.reject('DVR disabled');
					}

					let quality = stream.quality().find(quality => quality.default()) || stream.quality()[0] || null;
					if(self.quality() && stream.quality()) {
						quality = stream.quality().find((quality) => quality.number() === self.quality().number()) || quality;
					}
                    if (self.quality() !== quality) {
                        self.quality(quality);
                    }

					let language = stream.language().find(language => language.default()) || stream.language()[0] || null;
					if(self.language() && stream.language()) {
						language = stream.language().find((language) => language.channel() === self.language().channel()) || language;
					} else {
						language = stream.language().find((language) => language.label().toLowerCase() === $app.require('locale').getName()) || language;
					}
                    if (self.language() !== language) {
                        self.language(language);
                    }

                    if(episode.isRecorded()) {
                        playerStartTime(0);
                    } else if(episode.type() !== 'live') {
                        playerStartTime(episode.playerTimeStart());
                    } else {
                        playerStartTime(-1);
                    }

                    self.setPoster(stream.getPreview());

					$app.currentStream(stream);
					$app.currentStreamDay(episode.day());
					$app.currentEpisode(episode);
				} catch(e) {
					console.error('setEpisode', e);
				}

				return self.reload();
			})
			.then(function() {
				if(playerStartTime() >= 0) {
					self.setCurrentTime(playerStartTime());
				} else if (playerStartTime() === -1) {
                    self.virtualLive(true);
                }
				// if($app.episode() && $app.episode() === episode) {
				// 	if(episode.type() === 'live') return self.setLive();
				// 	if(!episode.isRecorded()) return self.setCurrentTime(episode.playerTimeStart());
				// } else if(!episode.isRecorded()) {
				// 	return episode.type() === 'live' ? self.setLive() : self.setCurrentTime(episode.playerTimeStart());
				// }
			})
		;
	};

	self.updateEpisodes = function(episodes) {
		//toolBar.initEpisodes(episodes);
	};

	self.isLoaded = function() { return isLoaded(); };

	self.load = function() {
		return new Promise(resolve => {
			if(!isLoaded()) {
				isLoading(true);
				playerContainer = document.getElementById('playerContainer');

				self.on('load', function() {
					isLoaded(true);
					isLoading(false);
					$app.require('comet')
						.on(['create:episode', 'update:episode', 'delete:episode'], function(episode) {
							if(!$app.currentStream() || episode.streamId !== $app.currentStream().id()) return;
							setTimeout(function() {
								self.updateEpisodes();
							}, 0);
						})
					;

					resolve();
				});

				getPlayer();
				getToolBar();

				$app.event().stream().forEach(function(stream) {
					stream.isLive.subscribe(function() {
						if($app.currentStream() && $app.currentStream().id() === stream.id()) {
							self.setStream(stream);
						}
					});
				});
			} else {
				resolve();
			}
		});
	};

	$app.on('setStream', function(stream) { self.setStream(stream); });
	$app.on('setEpisode', function(episode) { self.setEpisode(episode); });

	$(document).on('keyup', function(event) {
		function rewindPlayer(deltaTime) {
			if(!$app.currentStream().dvr()) return;
			const currentTime = self.currentTime();
			if(currentTime) {
				self.setCurrentTime(currentTime + deltaTime);
			}
		}
		function playTogglePlayer() {
			self.trigger(self.paused() ? 'play' : 'pause');
		}
		const Button = {
			LEFT: 37,
			TOP: 38,
			RIGHT: 39,
			BOTTOM: 40,
			SPACE: 32
		};
		if(in_array(event.target.tagName.toLowerCase(), ['input', 'textarea'])) return;
		event.preventDefault();
		switch(event.which) {
			case Button.LEFT: rewindPlayer(-10); event.preventDefault(); break;
			case Button.RIGHT: rewindPlayer(10); event.preventDefault(); break;
			case Button.SPACE: playTogglePlayer(); break;
		}
	});
}

PlayerHTML.isSupported = function() {
	return (
			typeof Hls !== 'undefined' && Hls.isSupported()
//			&& (!currentBrowser.isOpera()) && (!currentBrowser.isSafari() || (currentBrowser.isSafari() && currentBrowser.isMacOS() && $.cookie('dev_debug')))
//			&& $.cookie('dev_debug')
		)
		|| currentBrowser.isIOS() || currentBrowser.isAndroid() || currentBrowser.isWindowsPhone()
	;
};

export default PlayerHTML;
